"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.types = exports.sizes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SpinnerModule = _interopRequireDefault(require("./Spinner.module.scss"));

var _Spinner = _interopRequireDefault(require("./Spinner.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = ['small', 'medium', 'large'];
exports.sizes = sizes;
var types = ['default', 'benovative', 'bubble'];
exports.types = types;
Spinner.propTypes = {
  size: _propTypes.default.oneOf(sizes),
  type: _propTypes.default.oneOf(types),
  text: _propTypes.default.string
};
Spinner.defaultProps = {
  size: 'small',
  type: 'default',
  centered: false
};

function Spinner(_ref) {
  var size = _ref.size,
      type = _ref.type,
      centered = _ref.centered,
      className = _ref.className;
  var classes = (0, _classnames.default)(_SpinnerModule.default.Spinner, _SpinnerModule.default[size], _SpinnerModule.default[type], _defineProperty({}, _SpinnerModule.default.centered, centered), className);
  return _react.default.createElement("div", {
    className: classes
  }, type === 'benovative' && _react.default.createElement("img", {
    src: _Spinner.default,
    alt: ""
  }));
}

var _default = Spinner;
exports.default = _default;

//# sourceMappingURL=Spinner.js.map